import { useCallback } from 'react';

const useNavigation = () => {

  const navigateToSameTab = useCallback((url) => {
    if (url) {
      window.location.href = url;
    }
  }, []);

  const navigateToNewTab = useCallback((url) => {
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  }, []);

  const navigateToAppOrStore = useCallback(({ iosUrl, androidUrl, portalUrl }) => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      navigateToSameTab(iosUrl);
    }
    else if (/android/i.test(userAgent)) {
      navigateToSameTab(androidUrl);
    }
    else {
      navigateToNewTab(portalUrl);
    }
  }, [navigateToSameTab, navigateToNewTab]);

  return {
    navigateToSameTab,
    navigateToNewTab,
    navigateToAppOrStore
  };
};

export default useNavigation;